import { useCallback } from "react";
import { useSelector } from "react-redux";

import { EventsState } from "../../../../../../../store/types";
import {
	AllLayoutTypes, LayoutTypesMap, TemplateNames,
} from '../../../../../../../types/template-layouts';
import {
	ModuleMap,
	PageModuleType,
	PageModule,
} from '../../../../../../../types/working-model';
import LayoutSelector from "./layout-selector";
import Images from '../../../../session/editor/moduleControls/layout-images.json';
import classNames from "classnames";
import { replaceSpaceWithUnderscore } from "../../../../../../../utils/utils";

interface Props {
	selectedModule?: PageModuleType | null;
	selectedLayout: string | null;
	setSelectedLayout?: React.Dispatch<React.SetStateAction<AllLayoutTypes | null>>;
}

const SelectModuleLayout: React.FC<Props> = ({
	selectedModule,
	selectedLayout,
	setSelectedLayout
}) => {
	const { workingEvent } = useSelector((state: EventsState) => ({
		workingEvent: state.CreateEventReducer.workingEvent,
		templates: state.CreateEventReducer.templates,
		token: state.AuthReducer.token || '',
		user: state.AuthReducer.user,
	}));


	const moduleMemoized = useCallback(() => {
		return workingEvent?.homepage?.modules.find(module => module.id === selectedModule);
	}, [workingEvent, selectedModule]);

	const module: PageModule | undefined = moduleMemoized();

	const handleSelectLayout = (selectedType: AllLayoutTypes) => {
		if (!workingEvent || !workingEvent?.homepage) { return; }
		setSelectedLayout?.(selectedType);
	};


	function makeLayoutSelectors(
		moduleName: string,
		module: PageModule | undefined,
		handleSelectLayout: ((selectedType: AllLayoutTypes) => void),
		layout: { [key: string]: string },
		template: string
	): JSX.Element | null {
		if (!module) { return null; }
		const moduleNameStandardized = replaceSpaceWithUnderscore(moduleName.toLowerCase());
		return (
			<>
				{Object.values(layout)
					.map((layout) => {
						const key = `${replaceSpaceWithUnderscore(template)}-${moduleNameStandardized}-${layout}`;
						const src = `${process.env.REACT_APP_ASSET_SERVER}/template-previews/${(Images as { [key: string]: string })[key]}`;
						return <LayoutSelector
							key={template + moduleName + layout}
							selectedType={layout as AllLayoutTypes}
							currentType={selectedLayout ? selectedLayout : module?.content?.layout_type}
							handleSelectLayout={handleSelectLayout}
						>

							<div
								className={classNames('layout-thumbnail', moduleNameStandardized, layout)}
							>
								<img
									src={src}
									alt={layout}
								/>
							</div>
						</LayoutSelector>;
					}
					)
				}
			</>
		);
	}

	const renderList = (moduleType: PageModuleType) => {
		const templateName = workingEvent?.template?.name as TemplateNames;

		if (!templateName) { return null; }
		return makeLayoutSelectors(
			ModuleMap[moduleType],
			module,
			handleSelectLayout,
			LayoutTypesMap[templateName][moduleType],
			templateName);
	};

	if (!selectedModule || !module) { return <div />; }
	return (
		<div className="module-layout-items">
			{renderList(module.type)}
		</div>
	);
};

export default SelectModuleLayout;
